(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cinematicMotion = window.matchMedia('(min-width: 901px) and (prefers-reduced-motion: no-preference)');

  function initMaskedText(root = document) {
    if (reducedMotion.matches) return;

    const targets = root.querySelectorAll([
      '.section-header .sh-title',
      '.tf-brand-story-intro h2',
      '.tf-section-heading h2',
      '.ps-quote'
    ].join(','));

    if (!targets.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('motion-mask-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .18, rootMargin: '0px 0px -10% 0px' });

    targets.forEach(target => {
      if (target.dataset.motionMaskReady === 'true') return;

      const originalLabel = target.textContent.replace(/\s+/g, ' ').trim();
      const textNodes = [];
      const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.textContent.trim()
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT
      });

      while (walker.nextNode()) textNodes.push(walker.currentNode);

      let wordIndex = 0;
      textNodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        const parts = node.textContent.match(/\S+|\s+/g) || [];

        parts.forEach(part => {
          if (/^\s+$/.test(part)) {
            fragment.appendChild(document.createTextNode(part));
            return;
          }

          const mask = document.createElement('span');
          const inner = document.createElement('span');
          mask.className = 'motion-word-mask';
          inner.className = 'motion-word-inner';
          inner.style.setProperty('--motion-delay', `${Math.min(wordIndex * 55, 550)}ms`);
          inner.textContent = part;
          mask.appendChild(inner);
          fragment.appendChild(mask);
          wordIndex += 1;
        });

        node.replaceWith(fragment);
      });

      target.dataset.motionMaskReady = 'true';
      target.classList.add('motion-mask-ready');
      if (originalLabel) target.setAttribute('aria-label', originalLabel);
      observer.observe(target);
    });
  }

  function initProductEntrance(root = document) {
    if (reducedMotion.matches) return;
    const cards = root.querySelectorAll('.fp-grid .pcard, .collection-grid .pcard, .upsell-grid .pcard');
    if (!cards.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pcard-entrance-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -6% 0px' });

    cards.forEach((card, index) => {
      if (card.dataset.entranceReady === 'true') return;
      card.dataset.entranceReady = 'true';
      card.style.setProperty('--card-entrance-delay', `${(index % 4) * 85}ms`);
      card.classList.add('pcard-entrance-ready');
      observer.observe(card);
    });
  }

  let cinematicFrameId = 0;

  function updateCinematicMedia() {
    cinematicFrameId = 0;
    if (!cinematicMotion.matches) return;

    const viewportHeight = window.innerHeight;
    document.querySelectorAll('[data-cinematic-reveal].cinematic-ready').forEach(media => {
      const rect = media.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const revealDistance = viewportHeight * .78 + rect.height * .35;
      const progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / revealDistance));
      const centerOffset = (rect.top + rect.height * .5 - viewportHeight * .5) / viewportHeight;
      const shift = Math.max(-22, Math.min(22, centerOffset * -28));

      media.style.setProperty('--cinematic-mask', `${(100 - progress * 100).toFixed(2)}%`);
      media.style.setProperty('--cinematic-y', `${shift.toFixed(2)}px`);
    });
  }

  function requestCinematicUpdate() {
    if (!cinematicFrameId) cinematicFrameId = window.requestAnimationFrame(updateCinematicMedia);
  }

  function initCinematicMedia(root = document) {
    if (!cinematicMotion.matches) return;
    root.querySelectorAll('[data-cinematic-reveal]').forEach(media => {
      const colorImage = media.querySelector('[data-motion-src]');
      if (colorImage && !colorImage.getAttribute('src')) colorImage.setAttribute('src', colorImage.dataset.motionSrc);
      media.classList.add('cinematic-ready');
    });
    requestCinematicUpdate();
  }

  function init(root = document) {
    initMaskedText(root);
    initProductEntrance(root);
    initCinematicMedia(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    window.addEventListener('scroll', requestCinematicUpdate, { passive: true });
    window.addEventListener('resize', requestCinematicUpdate, { passive: true });
  });

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
